<main>
  <div class="page-content">
    <h5>gNB Custom Configuration</h5>

    <oaibox-ran-configuration-form
      [editableRanConfiguration]="customRanConfiguration"
      (ranConfigurationChanges)="updateConfiguration($event)"
    >
    </oaibox-ran-configuration-form>

    <div oaiboxStickyFooter class="footer">
      <button class="btn btn-ignore" (click)="goBack()">Discard</button>
      <button
        class="btn btn-warning"
        [oaiboxAuthorizedRoles]="[UserRole.ROOT]"
        (click)="resetConfiguration()"
      >
        Reset Configuration
      </button>
      <button
        class="btn btn-success"
        (click)="save()"
        [disabled]="requestOnGoing"
      >
        Save
        @if (requestOnGoing) {
          <i class="fa-solid fa-spinner rotating"></i>
        }
      </button>
    </div>
  </div>
</main>
